import { Box, IconButton, Button, useTheme } from "@mui/material";
import { useContext } from "react";
import { ColorModeContext, tokens } from "../../theme";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const EventCoordinatorTopbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate(); // Hook to navigate to the login page

  const handleLogout = () => {
    // Clear user data and perform any other necessary logout logic
    localStorage.removeItem("token");
    secureLocalStorage.removeItem("token");
    secureLocalStorage.removeItem("user");

    // Refresh the page, then navigate to /login
    setTimeout(() => {
      navigate("/login"); // Navigate after refresh
    }, 100); // Delay to ensure the refresh happens smoothly

    window.location.reload(); // Refresh the page
  };

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      p={2}
      sx={{
        position: "fixed", // Keep the topbar fixed at the top
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 100, // Ensure the topbar stays on top of other elements
      }}
    >
      {/* Theme Toggle Button */}
      <Box display="flex" alignItems="center">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon className="fs-1" />
          ) : (
            <LightModeOutlinedIcon className="fs-1" />
          )}
        </IconButton>

        {/* Logout Button */}
        <Button
          variant="contained"
          color="secondary"
          onClick={handleLogout}
          sx={{
            fontSize: "16px",
            padding: "6px 12px",
            marginLeft: "10px",
            borderRadius: "20px",
            // Add space between the theme toggle and logout button
          }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );
};

export default EventCoordinatorTopbar;
